export const API_URL_HERU: string = process.env.REACT_APP_API_HERU; 
export const API_URL_HERU_NEW_GATEWAY: string = process.env.REACT_APP_API_HERU_NEW_GATEWAY;
